import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useQueryClient } from '@tanstack/react-query';

export type DeleteWorkspaceConfirmationProps = {
  isOpen: boolean;
  handleOpen: (boolean: boolean) => void;
  workspaceId: string;
  organizationId: string;
};

export const DeleteWorkspaceConfirmation = ({
  isOpen,
  handleOpen,
  workspaceId,
  organizationId,
}: DeleteWorkspaceConfirmationProps) => {
  const queryClient = useQueryClient();
  const [deletingWorkspace, setDeletingWorkspace] = useState(false);

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete this
            workspace and remove all the data inside it from our servers.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={async e => {
              e.preventDefault();
              setDeletingWorkspace(true);
              await deleteWorkspace(workspaceId);
              queryClient.invalidateQueries({
                queryKey: ['getWorkspaces', organizationId],
              });
              setDeletingWorkspace(false);
              handleOpen(false);
            }}
            disabled={deletingWorkspace}
            className="bg-red-600 hover:bg-red-500 dark:text-white dark:hover:bg-red-700"
          >
            {deletingWorkspace ? 'Processing...' : 'Continue'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
